import * as types from './mutation-types'
import { Logger } from '@vue-storefront/core/lib/logger'

export function plugin(mutation, state) {
  if (types[mutation.type]) {
    Logger.info(`[Prismic] mutation ${mutation.type} performed.`)()
  }
}
